import { Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxPhone } from '@onyx/angular';
import {
  ActionHelper,
  OnyxAddressComponent,
  OnyxDatePipe,
  OnyxIconButtonComponent,
  OnyxIconComponent,
  OnyxInformationHeadingComponent,
  OnyxInformationListComponent,
  OnyxInformationRowComponent,
  OnyxPhonePipe,
  OnyxToastService,
  PhoneHelper,
} from '@onyx/angular';
import { AllowedCountriesComponent } from '../../../../../common/components/allowed-countries/allowed-countries.component';
import { CountryCellComponent } from '../../../../../common/components/cells/country-cell/country-cell.component';
import { StringCellComponent } from '../../../../../common/components/cells/string-cell/string-cell.component';
import { DictionaryCode } from '../../../../../common/enums/dictionary-code';
import type { Driver } from '../../../common/interfaces/driver';

@Component({
  selector: 'app-driver-modal-details',
  imports: [
    OnyxInformationRowComponent,
    TranslatePipe,
    CountryCellComponent,
    OnyxPhonePipe,
    OnyxAddressComponent,
    StringCellComponent,
    OnyxDatePipe,
    OnyxIconButtonComponent,
    OnyxInformationListComponent,
    OnyxIconComponent,
    OnyxInformationHeadingComponent,
    AllowedCountriesComponent,
  ],
  templateUrl: './driver-modal-details.component.html',
  styleUrl: './driver-modal-details.component.scss',
})
export class DriverModalDetailsComponent {
  private readonly toastService = inject(OnyxToastService);

  public readonly driver = input.required<Driver>();
  public readonly size = input.required<120 | 184>();

  protected readonly DictionaryCode = DictionaryCode;

  protected copyPhone(phone: OnyxPhone): void {
    ActionHelper.copy(PhoneHelper.composeLabel(phone), this.toastService);
  }
}
